module.exports = __webpack_public_path__ + "media/images/lp_05-002a92017727ce23b71fc7d7fcca4148.webp";